/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerExportTypeFilters.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Export Type Filters
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Tuesday, December 10, 2019 - 09:25:27 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      12/10/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    EXPORTTYPEFILTER_LIST_CONTAINER_LOADED,
    EXPORTTYPEFILTER_LIST_CONTAINER_UNLOADED,
    EXPORTTYPEFILTER_LIST_TABLE_LOADED,
    EXPORTTYPEFILTER_LIST_TABLE_UNLOADED,

    EXPORTTYPEFILTER_SELECT_ROW,
    EXPORTTYPEFILTER_UPDATE_VALUE,
    EXPORTTYPEFILTER_ADD,
    EXPORTTYPEFILTER_EDIT,
    EXPORTTYPEFILTER_DELETE,
    EXPORTTYPEFILTER_OPEN_WARNING,
    EXPORTTYPEFILTER_CLOSE_WARNING,
    EXPORTTYPEFILTER_DELETE_DISABLE,

    EXPORTTYPEFILTER_EDIT_CONTAINER_LOADED,
    EXPORTTYPEFILTER_EDIT_CONTAINER_UNLOADED,
    EXPORTTYPEFILTER_EDIT_FORM_LOADED,
    EXPORTTYPEFILTER_EDIT_FORM_UNLOADED,
    EXPORTTYPEFILTER_EDIT_DATA_LOAD,
    EXPORTTYPEFILTER_EDIT_CONTAINER_SUBMIT,
    EXPORTTYPEFILTER_EDIT_CONTAINER_CANCEL,

    EXPORTTYPEFILTER_SET_DATATYPE_SELECT
} from '../constants/actionTypeExportTypeFilters';

const defaultState = {
    refreshList: false,
    danger: false,
    exporttypefilterid: 0,
    exporttypeid: 0,
    exporttype: '',
    name: '',
    description: '',
    parameter: '',
    datatypeid: 0,
    required: 0,
    orderid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case EXPORTTYPEFILTER_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                exporttypefilters: action.payload[0] ? action.payload[0].records : null
            }
        case EXPORTTYPEFILTER_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case EXPORTTYPEFILTER_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case EXPORTTYPEFILTER_SELECT_ROW:
            return {
                ...state,
                exporttypefilterid: action.id
            }
        case EXPORTTYPEFILTER_ADD:
            return {
                ...state
            }
        case EXPORTTYPEFILTER_EDIT:
            return {
                ...state,
                exporttypefilterid: action.id
            }
        case EXPORTTYPEFILTER_DELETE:
            return {
                ...state,
                exporttypefilterid: null
            }
        case EXPORTTYPEFILTER_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case EXPORTTYPEFILTER_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case EXPORTTYPEFILTER_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case EXPORTTYPEFILTER_EDIT_CONTAINER_LOADED:
        case EXPORTTYPEFILTER_EDIT_DATA_LOAD:
            return {
                ...state,
                exporttypefilterid: action.payload[0] ? action.payload[0].exporttypefilterid : 0,
                exporttypeid: action.payload[0] ? action.payload[0].exporttypeid : 0,
                exporttype: action.payload[0] ? action.payload[0].exporttype : '',
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                parameter: action.payload[0] ? action.payload[0].parameter : '',
                datatypeid: action.payload[0] ? action.payload[0].datatypeid : 0,
                required: action.payload[0] ? action.payload[0].required : 0,
                orderid: action.payload[0] ? action.payload[0].orderid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case EXPORTTYPEFILTER_SET_DATATYPE_SELECT:
            return {
                ...state,
                dataTypeOptions: action.payload ? action.payload : []
            }

        case EXPORTTYPEFILTER_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case EXPORTTYPEFILTER_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case EXPORTTYPEFILTER_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case EXPORTTYPEFILTER_LIST_CONTAINER_UNLOADED:
        case EXPORTTYPEFILTER_LIST_TABLE_UNLOADED:
        case EXPORTTYPEFILTER_EDIT_CONTAINER_UNLOADED:
        case EXPORTTYPEFILTER_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerExportTypeFilters.js